// extracted by mini-css-extract-plugin
export default {"melodyVideo":"QM-z","isFullWidth":"RM-z","landingPageVideo":"SM-z","play":"TM-z","iframeVideo":"UM-z","playHidden":"VM-z","fullwidth":"WM-z"};